// services/purchases/BasePurchaseService.ts
import { purchaseApi } from '../../api';
import { PurchaseFinalizeDTO } from '../../mappers/purchase/finalize/types';
import {
  PurchaseFormValues,
} from '../../types/purchases/BasePurchase';

const BasePurchaseService = {
  /**
   * Genera una nueva compra
   * POST /api/purchases/generate
   */
  generate: async (purchase: PurchaseFormValues) => {
    const response = await purchaseApi.addCustom('/generate', purchase);
    return response.data;
  },

  /**
   * Obtiene una compra por su ID incluyendo el encabezado y productos
   * GET: http://localhost:8080/api/purchases/13
   */
  getPurchaseById: async (id: number) => {
    const response = await purchaseApi.fetchById(id);
    return response.data;
  },

  /**
   * Obtiene el total de compras pendientes en Casa Matriz
   * GET /api/purchases/pending-total
   */
  getPendingTotalCasaMatriz: async () => {
    const response = await purchaseApi.fetchCustom('/pending-total');
    return response
  },

  /**
   * Obtiene la lista de compras pendientes en Casa Matriz
   * GET /api/purchases/pending/casa-matriz
   */
  getPendingPurchasesCasaMatriz: async () => {
    const response = await purchaseApi.fetchCustom('/pending/casa-matriz');
    return response.data;
  },

  /**
 * Obtiene el total de compras finalizadas en Casa Matriz (excluyendo notas)
 * GET /api/purchases/finalized-total
 */
  getFinalizedTotalCasaMatriz: async () => {
    const response = await purchaseApi.fetchCustom('/finalized-total');
    return response;
  },

  /**
   * Obtiene la lista de compras finalizadas en Casa Matriz (excluyendo notas)
   * GET /api/purchases/finalized/casa-matriz
   */
  getFinalizedPurchasesCasaMatriz: async () => {
    const response = await purchaseApi.fetchCustom('/finalized/casa-matriz');
    return response.data;
  },

  /**
   * Finaliza una compra por ID
   * PATCH /api/purchases/{id}/finalize
   */
  finalizePurchase: async (id: number, data: PurchaseFinalizeDTO) => {
    const response = await purchaseApi.modifyCustom(`/${id}/finalize`, data);
    return response.data;
  },

  /**
  * Filtra y pagina las compras según los criterios proporcionados.
  * POST /api/purchases/filtered
  */
  getFilteredPurchases: async (filters: any, page = 0, size = 10, sort = 'id,desc') => {
    const response = await purchaseApi.addCustom(`/filtered?page=${page}&size=${size}&sort=${sort}`, filters);
    return response.data;
  },

  /**
   * Actualiza el encabezado de una compra por su ID
   * PUT /api/purchases/{id}/update-header
   */
  updatePurchaseHeader: async (id: number, purchase: any) => {
    const response = await purchaseApi.modifyCustom(`/${id}/update-header`, purchase);
    return response.data;
  },

  /**
   * Cancela una compra que todavía está en PENDING (estado DRAFT_CANCELLED).
   * No es el flujo fiscal de anulación/invalidación.
   * PUT /api/purchases/{id}/cancel-pending
   */
  cancelPendingPurchase: async (id: number, reason?: string) => {
    const query = reason ? `?reason=${encodeURIComponent(reason)}` : '';
    const response = await purchaseApi.modifyCustom(`/${id}/cancel-pending${query}`, {});
    return response.data;
  },


};


export default BasePurchaseService;
